import JsonHandler from './json-handler.js';
import ResponseHandler from './response-handler.js';

export default class RequestHandler {
    constructor(debug = false) {
        this.JsonHandler = new JsonHandler;
        this.ResponseHandler = new ResponseHandler;
        this.debug = debug;
    }

    /** data can be an object or query string.
     */
    get(url, data, callback) {
        let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP'),
            params = this.buildQueryString(data);

        xhr.open('GET', url + '?' + params);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (callback) {
            this.handleOnReadyStateChange(xhr, callback, url);
        }
        xhr.send();
    }

    /** data can be an object or query string.
     */
    post(url, data, callback) {
        let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP'),
            params = this.buildQueryString(data);

        xhr.open('POST', url);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (callback) {
            this.handleOnReadyStateChange(xhr, callback, url);
        }
        xhr.send(params);
    }

    handleOnReadyStateChange(xhr, callback, url) {
        xhr.onreadystatechange = () => {
            if (!this.isHttpError(xhr.status) && xhr.readyState > 3) {
                const response = this.JsonHandler.parse(xhr.responseText);
                if (this.debug && !this.ResponseHandler.isSuccess(response)) {
                    console.error(this.ResponseHandler.getErrors(response), 'API Error for ' + url);
                }
                callback(response);
            } else if (this.isHttpError(xhr.status)) {
                console.error(xhr.responseText, 'HTTP Error Status ' + xhr.status);
            }
        };

        return xhr;
    }

    isHttpError(status) {
        return status.toString().charAt(0) !== '2';
    }

    buildQueryString(data) {
        if (data === null) {
            return '';
        }

        let params = typeof data === 'object' ?
            Object.keys(data).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(data[k])).join('&') : data;

        if (typeof data === 'string' && params.charAt(0) === '?') {
            params = params.slice(1);
        }

        return params;
    }
}
